import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"
import { CheckCircle2, Clock, XCircle, Eye, Target, AlertTriangle } from "lucide-react"

type SignalStatus = 
  | "active" 
  | "pending" 
  | "closed" 
  | "observation" 
  | "target-hit" 
  | "stop-hit"

interface SignalStatusBadgeProps {
  status: SignalStatus
  language?: "en" | "es"
  className?: string
}

const statusConfig = {
  active: {
    en: "Active",
    es: "Activa",
    icon: CheckCircle2,
    class: "bg-primary/20 text-primary border-primary/30",
  },
  pending: {
    en: "Pending",
    es: "Pendiente",
    icon: Clock,
    class: "bg-primary/20 text-primary border-primary/30",
  },
  closed: {
    en: "Closed",
    es: "Cerrada",
    icon: XCircle,
    class: "bg-muted/20 text-muted-foreground border-muted/30",
  },
  observation: {
    en: "Observation",
    es: "Observación",
    icon: Eye,
    class: "bg-secondary/20 text-secondary border-secondary/30",
  },
  "target-hit": {
    en: "Target Hit",
    es: "Objetivo",
    icon: Target,
    class: "bg-primary/30 text-primary border-primary/40",
  },
  "stop-hit": {
    en: "Stop Hit",
    es: "Stop",
    icon: AlertTriangle,
    class: "bg-destructive/20 text-destructive border-destructive/30",
  },
}

export function SignalStatusBadge({ 
  status, 
  language = "en",
  className 
}: SignalStatusBadgeProps) {
  const config = statusConfig[status]
  const Icon = config.icon
  
  return (
    <Badge 
      variant="outline" 
      className={cn(
        config.class,
        "font-medium text-xs flex items-center gap-1.5",
        className
      )}
    >
      <Icon className="w-3 h-3" />
      {config[language]}
    </Badge>
  )
}
